// Tiny haptic feedback wrapper. On native (Capacitor) it uses the Haptics
// plugin; on the web it falls back to navigator.vibrate when available.
// All functions are fire-and-forget and never throw.
import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

const isNative = () => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
};

function webVibrate(pattern) {
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch {}
}

export const haptics = {
  // Light tap — shoot arrow, UI button press.
  light() {
    if (isNative()) Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
    else webVibrate(10);
  },

  // Medium tap — arrow pack pickup, timer ticking down.
  medium() {
    if (isNative()) Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
    else webVibrate(20);
  },

  // Heavy tap — something big (boss death, chain complete).
  heavy() {
    if (isNative()) Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {});
    else webVibrate(40);
  },

  // Negative notification — skull hit, out of arrows.
  error() {
    if (isNative()) Haptics.notification({ type: NotificationType.Error }).catch(() => {});
    else webVibrate([30, 40, 30]);
  },

  // Positive notification — round win, unlock.
  success() {
    if (isNative()) Haptics.notification({ type: NotificationType.Success }).catch(() => {});
    else webVibrate([15, 40, 15]);
  },

  // Warning — low-timer warning etc.
  warning() {
    if (isNative()) Haptics.notification({ type: NotificationType.Warning }).catch(() => {});
    else webVibrate([20, 30, 20]);
  },
};
